import { LANGUAGE_RECEIVE_LANGUAGES, LANGUAGE_CURRENT_CLASSNAME, LANGUAGE_RECEIVE_DICTIONARIES, LANGUAGE_LOAD_ERROR, LANGUAGE_CURRENT } from '../../constants';
import { get } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';

const firstHtml = document.querySelector('html');
const iso = firstHtml.getAttribute('lang');

export const getLanguages = () => async (dispatch, getState) => {
    try {
        const response = await get('/api/navigation/languages');
        const data = await response.json();
        dispatch(receiveLanguages(data));
        return data;
    } catch (ex) {
        dispatch(catchError(ex, (error) => loadError(error)));
        throw ex;
    }
};

export const getDictionaries = () => async (dispatch) => {
    return get(`/api/navigation/dictionaries/${iso}`)
        .then((response) => response.json())
        .then((data) => dispatch(receiveDictionaries(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const setCurrentLanguageClass = (data) => ({
    type: LANGUAGE_CURRENT_CLASSNAME,
    payload: {
        currentLanguageClassName: data,
    },
});

export const setCurrentLanguageIso = (data) => ({
    type: LANGUAGE_CURRENT,
    payload: {
        currentLanguageIso: data,
    },
});

export const receiveLanguages = (data) => ({
    type: LANGUAGE_RECEIVE_LANGUAGES,
    payload: {
        languages: data,
    },
});

export const receiveDictionaries = (data) => ({
    type: LANGUAGE_RECEIVE_DICTIONARIES,
    payload: {
        dictionaries: data,
    },
});

export const loadError = (error) => ({
    type: LANGUAGE_LOAD_ERROR,
    payload: {
        error,
    },
});
